<template>
  <div class="modal_mask">
    <div class="wrapper_modal_other_currencies">
      <div class="content_other_currencies">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          @click="toggleModalPriceHist()"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
        <div class="title_other_currencies" style="text-align: center">
          <!-- {{selectedCurrency.currency.name}} ({{selectedCurrency.currency.symbol}}) -->

          {{ $t("msg.price_history_list") }}
        </div>
        <!-- <div class="currencies_equivalent">
          {{priceHist.data.length}} aa
        </div> -->

        <div class="component_table">
          <vue-good-table
            :columns="tableColumns"
            :rows="priceHist.data"
            :sort-options="{
              enabled: true,
              initialSortBy: { field: 'at', type: 'asc' },
            }"
            :pagination-options="{
              enabled: true,
              perPage: 10,
              position: 'bottom',
              perPageDropdown: [10, 15, 20],
              dropdownAllowAll: false,
              setCurrentPage: 1,
              nextLabel: $tc('msg.next', 2),
              prevLabel: $tc('msg.previous', 2),
              rowsPerPageLabel: $t('msg.rows_per_page'),
              ofLabel: $t('msg.of'),
              pageLabel: $t('msg.page'), // for 'pages' mode
              allLabel: $t('msg.all'),
            }"
          >
            <template slot="table-column" slot-scope="props">
              <span v-if="props.column.label == 'createdAt'">{{
                $t("msg.createdAt")
              }}</span>
              <span v-if="props.column.label == 'price'"
                >{{ $t("msg.price") }} USDT</span
              >
            </template>

            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'at'">
                {{
                  fixTimeTest(props.formattedRow[props.column.field]).slice(
                    0,
                    -10
                  )
                }}
                <br />
              </span>
              <span v-else-if="props.column.field == 'max'">
                {{ props.formattedRow[props.column.field].toFixed(2) }}
              </span>
            </template>
          </vue-good-table>
        </div>
        <button>{{ $t("msg.download_csv") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["type", "priceHist"],
  created() {
    this.tableColumns[0].label = this.$t("msg.closing_price");
  },
  data: () => ({
    prices: [
      {
        createdAt: "22/07/1994",
        price: 100,
      },
    ],
    blue: {},
    fundTails: {},
    tableColumns: [
      {
        label: "",
        field: "at",
        sortable: true,
      },
      {
        label: "price",
        field: "max",
        type: "number",
      },
    ],
  }),
  methods: {
    toggleModalPriceHist() {
      this.$emit("toggleModal");
    },
  },
  watch: {
    "$i18n.locale": function () {
      this.tableColumns[0].label = this.$t("msg.closing_price");
    },
  },
};
</script>


<style lang="scss" scope>
.modal_mask {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 998;
  overflow: auto;
}

.wrapper_modal_other_currencies {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .content_other_currencies {
    position: relative;
    padding: 1rem;
    border-radius: 6px;
    max-width: 500px;
    width: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;

    .component-table {
      overflow-y: auto;
      width: 100%;
    }

    .title_other_currencies {
      display: flex;
      border-bottom: 1px solid #342365 !important;
      padding-bottom: 0.5rem;
      width: 100%;
      font-size: 1.5rem;
      font-weight: 600;
      text-align: center;
      justify-content: center;
      color: #342365;

      .usdt_value {
        display: flex;
        align-items: center;
        img {
          width: 1.4rem;
          margin-right: 10px;
        }

        span {
          font-size: 1rem;
          font-weight: 600;
        }
      }
    }

    svg {
      position: absolute;
      top: 0.5rem;
      width: 1.2rem;
      right: 0.5rem;
      cursor: pointer;

      &:hover {
        color: #342365;
      }
    }

    .currencies_equivalent {
      display: flex;
      flex-direction: column;
      align-items: center;

      h2 {
        font-size: 1rem;
        font-weight: 600;
        margin: 1.2rem 0;
      }

      .wrapper_currencies_list {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .currencies_list {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 0.8rem;

          span {
            font-size: 1rem;
            font-weight: 600;
          }

          img {
            width: 1.4rem;
            margin-left: 15px;
          }

          .currencies_icon {
            width: 1.4rem;
            height: 1.4rem;
            margin-left: 15px;
          }
        }
      }

      p {
        margin-top: 0.5rem;
      }
    }

    button {
      outline: none;
      padding: 8px 20px;
      color: white;
      border-radius: 6px;
      background: #342365;
      border: none;
      cursor: pointer;
      font-size: 1rem;
      transition: all ease-in-out 0.2s;

      &:hover {
        opacity: 0.9;
      }
    }
  }
}

@media only screen and (max-width: 500px) {
  .wrapper_modal_other_currencies {
    .content_other_currencies {
      padding: 2rem 1.5rem;
      max-width: 350px;
    }
  }
}

@media only screen and (max-width: 350px) {
  .wrapper_modal_other_currencies {
    .content_other_currencies {
      max-width: 300px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/modalPriceHist.vue